export const PART_TO_BE_MADE = 'wo_part';
export const QUANTITY_DEFAULT_VALUE = 1;
